var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMetalMusic = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Concert-Rock--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Concert Rock Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14 18.66a2.33 2.33 0 0 1 0.34 -2.48l2.48 -3a1 1 0 0 0 0.22 -0.63v-8a1.5 1.5 0 0 0 -3 0v3a1 1 0 0 1 -1 1h-4.5a1 1 0 0 1 -1 -1V2a1.5 1.5 0 1 0 -3 0v7.26a0.5 0.5 0 0 1 -0.31 0.47 0.51 0.51 0 0 1 -0.55 -0.12l-1 -1a1.59 1.59 0 0 0 -1.13 -0.47 1.51 1.51 0 0 0 -1.11 0.48 1.54 1.54 0 0 0 -0.14 2l5.45 7.07a1 1 0 0 0 0.46 0.33 0.5 0.5 0 0 1 0.33 0.48L6.5 23a0.51 0.51 0 0 0 0.5 0.5h7a0.51 0.51 0 0 0 0.5 -0.49l0.05 -3.38a0.54 0.54 0 0 0 -0.14 -0.36 2.21 2.21 0 0 1 -0.41 -0.61Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.92 16a0.81 0.81 0 0 0 -0.74 -0.48h-1a0.5 0.5 0 0 1 -0.5 -0.5V11a0.5 0.5 0 0 0 -0.88 -0.32l-5.28 6.47a0.82 0.82 0 0 0 0.63 1.35h1a0.5 0.5 0 0 1 0.5 0.5v4a0.5 0.5 0 0 0 0.89 0.32l5.27 -6.47a0.8 0.8 0 0 0 0.11 -0.85Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMetalMusic);
export default ForwardRef;